{
  "maintenance_screen_enabled": "false",
  "get_markers_polling_interval": "0",
  "no_of_customer_widgets_allowed": "16",
  "display_warranty": "false",
  "dashboard_widgets_polling_interval": "60000",
  "feedback_url": "",
  "display_fatal_error_filter": "false",
  "dealers_report": "",
  "no_of_user_defined_widgets_allowed": "10",
  "display_streaming_map": "",
  "display_grouped_list_widgets": "",
  "app_status_config": "",
  "incident_communication_enabled": "false",
  "enable_epos_area": "false",
  "enable_favorit_companies_filter": "false",
  "enable_gutter": "false"
}